<template>
  <div class="notifications">
    <div
      v-for="(item, index) in notifications"
      class="notifications__item"
      :class="getClass(item.type)"
      :key="index"
    >
      <div class="notifications__item__icons" v-if="item.type != null">
        <svg
          v-if="item.type === 'success'"
          class="success-icon"
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.7619 17.4772C21.6293 17.4772 23.8701 15.3789 23.8701 12.7677C23.8701 10.7738 22.7212 9.04573 20.8697 8.26716C20.8887 4.03244 17.8408 0.975098 13.9575 0.975098C11.3844 0.975098 9.55184 2.35186 8.41245 4.01346C6.07672 3.32983 3.53209 5.10537 3.48461 7.76393C1.33877 8.10574 0 10.0237 0 12.3405C0 15.1319 2.44019 17.4772 5.68743 17.4772H18.7619ZM18.7619 15.9485H5.68743C3.29472 15.9485 1.52868 14.2774 1.52868 12.3405C1.52868 10.4415 2.67756 8.93179 4.69047 8.93179C4.8234 8.93179 4.87087 8.86533 4.87087 8.7419C4.87087 5.81748 6.97872 4.95345 8.92518 5.5896C9.03912 5.62759 9.10557 5.5991 9.16255 5.49466C10.0836 3.85204 11.4983 2.50378 13.9575 2.50378C17.0718 2.50378 19.2271 4.97244 19.3885 7.79241C19.417 8.22918 19.3885 8.7419 19.3505 9.18816C19.3411 9.31159 19.3885 9.37806 19.5025 9.40654C21.2305 9.78633 22.3414 11.0491 22.3414 12.7677C22.3414 14.5338 20.7843 15.9485 18.7619 15.9485ZM11.2609 13.7457C11.5742 13.7457 11.8401 13.5938 12.0205 13.3089L15.733 7.2607C15.8279 7.10878 15.9513 6.8904 15.9513 6.67202C15.9513 6.25425 15.5906 5.94091 15.1443 5.94091C14.8784 5.94091 14.6221 6.10233 14.4702 6.36819L11.223 11.7897L9.58982 9.65341C9.40941 9.40655 9.17204 9.27362 8.88719 9.27362C8.45993 9.27362 8.11811 9.61543 8.11811 10.0617C8.11811 10.2611 8.19407 10.451 8.3365 10.6409L10.4633 13.3184C10.6912 13.6127 10.9476 13.7457 11.2609 13.7457Z"
            fill="white"
          />
        </svg>
        <svg
          v-else
          class="error-icon"
          width="23"
          height="18"
          viewBox="0 0 23 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.078 16.4566C20.8409 16.4566 23 14.364 23 11.7601C23 9.77165 21.8929 8.04837 20.1089 7.27194C20.1273 3.04891 17.1905 0 13.4487 0C10.9694 0 9.20365 1.37296 8.1058 3.02998C5.85521 2.34824 3.40334 4.11888 3.35759 6.7701C1.28997 7.11097 0 9.02365 0 11.3341C0 14.1178 2.35124 16.4566 5.48011 16.4566H18.078ZM18.078 14.9321H5.48011C3.17462 14.9321 1.47295 13.2656 1.47295 11.3341C1.47295 9.44027 2.57995 7.93475 4.51949 7.93475C4.64757 7.93475 4.69332 7.86847 4.69332 7.74538C4.69332 4.82903 6.72433 3.96738 8.59984 4.60177C8.70962 4.63966 8.77366 4.61125 8.82856 4.50709C9.71599 2.869 11.0792 1.52446 13.4487 1.52446C16.4495 1.52446 18.5262 3.98632 18.6818 6.79851C18.7092 7.23407 18.6818 7.74538 18.6451 8.19041C18.636 8.3135 18.6818 8.37978 18.7916 8.40819C20.4566 8.78693 21.527 10.0462 21.527 11.7601C21.527 13.5213 20.0267 14.9321 18.078 14.9321ZM9.74344 12.1956L11.5 10.3776L13.2566 12.1956C13.5311 12.4702 13.9062 12.4134 14.1531 12.1767C14.391 11.9305 14.4459 11.5328 14.1806 11.2582L12.4149 9.4308L14.1806 7.60335C14.4459 7.32875 14.391 6.94054 14.1531 6.68489C13.9244 6.4387 13.5311 6.38189 13.2566 6.66595L11.5 8.48394L9.74344 6.66595C9.47813 6.39136 9.09387 6.44817 8.856 6.68489C8.60898 6.93107 8.56323 7.32875 8.82856 7.60335L10.5851 9.4308L8.82856 11.2582C8.56323 11.5328 8.61813 11.921 8.84685 12.1672C9.08472 12.4229 9.47813 12.4702 9.74344 12.1956Z"
            fill="white"
          />
        </svg>
      </div>
      <span>{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Notification",
  data() {
    return {
      notifications: [],
    };
  },
  methods: {
    ...mapActions(["emitNotification"]),
    addNotification(value) {
      if (this.notifications.length >= 3) {
        this.notifications.shift();
      }
      const id = Date.now();
      this.notifications.push({ ...value, id: id });
      this.emitNotification(null);
      setTimeout(() => {
        this.removeObjectWithId(id);
      }, 5000);
    },
    removeObjectWithId(id) {
      const index = this.notifications.findIndex((obj) => obj.id === id);
      if (index > -1 && this.notifications[index].id === id) {
        this.notifications.splice(index, 1);
      }
    },
    getClass(type) {
      return `notifications__item--${type}`;
    },
  },
  computed: {
    ...mapGetters(["getNotification"]),
  },
  watch: {
    getNotification: {
      handler(value) {
        if (value !== null) {
          this.addNotification(value);
        }
      },
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
